import * as lodash from 'lodash';
import { DashboardNodeModel, WidgetsEdgesModel, WidgetParametrosModel, WidgetsParamsResponse, WidgetDevicesResponse, WidgetDatatypeResponse } from '../../graphQL/widgets-graphQL-response';
import { NewDashbordModel, NewWidgetsModel, DevicesModel, DataTypeModel } from '../../dashboard/newDashboard.model';
import { WidgetType } from '../widget-interfaces.model';
import { ChartOrientationType } from '../../plotly/plotly-chart.model';

export interface MappedPeriod {
    clave: string;
    valor: string;
    cantidad: string;
}

export class NewDashboardMapper {

    public static fromDashboardResponseCollectionToDashboardCollection(dashCollection: any, language: string): NewDashbordModel[] {
        if (lodash.isEmpty(dashCollection)) { return []; }
        const auxDashboardCollectionMultiple: NewDashbordModel[][] = [];
        let auxDashboardCollection: NewDashbordModel[] = [];  
        auxDashboardCollectionMultiple.push(dashCollection.map(item => this.fromDashboardResponseToNewDashboard(item.node, language)));        
        return auxDashboardCollection = lodash.flatten(auxDashboardCollectionMultiple);
    }

    public static fromDashboardResponseToNewDashboard(item: DashboardNodeModel, language: string): NewDashbordModel {
        const newDashboard: NewDashbordModel = new NewDashbordModel(item.uuid, item.nombre, []);
        newDashboard.widgets = this.fromWidgetsResponseToNewWidgetCollection(item.widgetsConnection.edges, language);
        return newDashboard;
    }
    public static fromWidgetsResponseToNewWidgetCollection(widget: WidgetsEdgesModel[], language: string): NewWidgetsModel[] {
        return widget.map(item => {
            if (!lodash.isEmpty(item.node.parametros)) {
                const newWidget: NewWidgetsModel = new NewWidgetsModel();
                newWidget.uuid = item.node.uuid;
                newWidget.name = item.node.nombre;
                newWidget.widgetType = this.getWidgetType(item.node.parametros);
                if (newWidget.widgetType === WidgetType.GAUGE) {
                    newWidget.limit = this.getLimitParam(item.node.parametros);
                    newWidget.min = this.getMinParam(item.node.parametros);
                    newWidget.max = this.getMaxParam(item.node.parametros);
                }
                newWidget.devices = [];
                newWidget.dataType = [];
                newWidget.x = item.x !== null ? item.x : 0;
                newWidget.y = item.y !== null ? item.y : 0;
                newWidget.rows = item.height !== null ? item.height : 3;
                newWidget.cols = item.width !== null ? item.width : 4;
                newWidget.relationUuid = item.uuid;
                newWidget.devices = this.getDeviceCollection(item.node.parametros);
                newWidget.dataType.addRange(this.getDatatypeCollection(item.node.parametros, language));
                newWidget.dataTypeGrouped = newWidget.dataType.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)).reduce((td, x) => td.concat(td.find(y => y.codigo === x.codigo) ? [] : [x]), []),
                newWidget.period = this.getPeriod(item.node.parametros);
                newWidget.orientation = this.getOrientation(item.node.parametros);
                if (newWidget.widgetType !== undefined) {
                    return newWidget;
                } else {
                    return null;
                }
            }
        });
    }

    private static getLimitParam(params: WidgetsParamsResponse[]): number {
        let limit: number;
        // tslint:disable-next-line: radix
        params.map(item => { if (item.clave === 'limite') { limit = parseInt(item.valor); } });
        return limit;
    }

    private static getMinParam(params: WidgetsParamsResponse[]): number {
        let min: number;
        // tslint:disable-next-line: radix
        params.map(item => { if (item.clave === 'min') { min = parseInt(item.valor); } });
        return min;
    }

    private static getMaxParam(params: WidgetsParamsResponse[]): number {
        let max: number;
        // tslint:disable-next-line: radix
        params.map(item => { if (item.clave === 'max') { max = parseInt(item.valor); } });
        return max;
    }

    private static getPeriod(params: WidgetsParamsResponse[]): MappedPeriod {
        const newMappedPeriod: MappedPeriod = {
            clave: '',
            valor: '',
            cantidad: ''
        };
        if (params.length > 0) {
            params.map(item => {
                if (item.clave === 'periodo') {
                    newMappedPeriod.clave = item.clave;
                }
            });
            params.map(item => {
                if (item.clave === 'Hour' || item.clave === 'Day' ||
                    item.clave === 'Week' || item.clave === 'Month' || item.clave === 'horas') {
                    newMappedPeriod.valor = item.clave;
                    newMappedPeriod.cantidad = item.valor;
                }
            });
        }
        return newMappedPeriod;
    }

    private static getDeviceCollection(devices: WidgetsParamsResponse[]): DevicesModel[] {
        if (devices.length > 0) {
            const auxArray: WidgetsParamsResponse[] = devices.filter(item => item.clave === 'dises' ||
                item.clave === 'dis');
            if (!lodash.isEmpty(auxArray)) {
                return lodash.flatten(auxArray.map(item => this.iteratesDevice(item.dispositivos)));
            }
        }
    }
    private static iteratesDevice(deviceCollection: WidgetDevicesResponse[]): DevicesModel[] {
        const arr: DevicesModel[] = [];
        deviceCollection.map(device => {
            const newDevice: DevicesModel = new DevicesModel();
            newDevice.name = device.nombre;
            newDevice.uuid = device.uuid;
            if (lodash.isEmpty(newDevice)) {
            } else {
                arr.push(newDevice);
            }

        });
        if (arr.length > 0) {
            return arr;
        }


    }
    private static getDatatypeCollection(dataTypeCollection: WidgetsParamsResponse[], language: string): DataTypeModel[] {
        if (dataTypeCollection.length > 0) {
            const auxArray: WidgetsParamsResponse[] = dataTypeCollection.filter(item => item.clave === 'tipomeds' ||
                item.clave === 'tipomed');
            if (!lodash.isEmpty(auxArray)) {
                return lodash.flatten(auxArray.map(item => this.iteratesDatatype(item.tipodatos, language)));
            }
        }
    }

    private static iteratesDatatype(dataTypeCollection: WidgetDatatypeResponse[], language: string): DataTypeModel[] {
        const newDataTypeCollection: DataTypeModel[] = [];

        dataTypeCollection.map(dataType => {
            const newDatatype: DataTypeModel = new DataTypeModel();
            switch(language) {
                case 'en':
                    newDatatype.name = dataType.nombre_en;
                    break;
                case 'es':
                    newDatatype.name = dataType.nombre_es;
                    break;
                default:
                    newDatatype.name = dataType.nombre_es;
            }
            newDatatype.uuid = dataType.uuid;
            newDatatype.unity = dataType.unidad;
            newDatatype.codigo = dataType.codigo;
            if(newDatatype.codigo === null) {newDatatype.codigo = dataType.uuid}
            newDataTypeCollection.push(newDatatype);
        });
        return newDataTypeCollection;

    }

    private static getWidgetType(widgetParamCollection: WidgetParametrosModel[]): WidgetType {
        if (lodash.isEmpty(widgetParamCollection)) {
            return null;
        }

        if (widgetParamCollection.any(item => item.clave === 'limite')) {
            return WidgetType.GAUGE;
        } else if (
            widgetParamCollection.any(
                item => item.clave === 'tipoplot' && item.valor === 'ClusteredColumns' || item.valor === 'bar')) {
            return WidgetType.CLUSTER_COLUMN;
        } else if (
            widgetParamCollection.any(
                item => item.clave === 'tipoplot' && (item.valor === 'Lines' || item.valor === 'scatter'))) {
            return WidgetType.LINE;
        } else if (
            widgetParamCollection.any(
                item => item.clave === 'tipoplot' && item.valor === 'Pie')) {
            return WidgetType.PIE;
        } else if (
            widgetParamCollection.any(
                item => item.clave === 'tipoplot' && item.valor === 'Areas')) {
            return WidgetType.AREA;
        } else if (
            widgetParamCollection.any(
                item => item.clave === 'tipoplot' && item.valor === 'table')) {
            return WidgetType.TABLE;
        } else if (
            widgetParamCollection.any(
                item => item.clave === 'tipoplot' && item.valor === 'digital')) {
            return WidgetType.DIGITAL;
            } else {
            return WidgetType.UNDEFINED;
        }
    }

    private static getOrientation(widgetParamCollection: WidgetsParamsResponse[]): ChartOrientationType {
        if (lodash.isEmpty(widgetParamCollection)) {
            return null;
        }
        if (widgetParamCollection.any(item => item.clave === 'orientation' && item.valor === 'v')) {
            return ChartOrientationType.VERTICAL;
        } else if (widgetParamCollection.any(item => item.clave === 'orientation' && item.valor === 'h')) {
            return ChartOrientationType.HORIZONTAL;
        } else {
        return ChartOrientationType.NONE;
        }
    }
}
